//October libs
import '../../../modules/system/assets/js/framework';
import '../../../modules/system/assets/js/framework.extras';
import 'focus-visible';
import '../partials/form/input/validation';

import '../partials/common/menu/menu';
import '../partials/common/languages/languages';
import '../partials/form/input/input';
import '../partials/modal/modal';
import '../partials/common/cookie/cookie';
import '../partials/common/subscribe/subscribe';

$(document).ready(function(){
    $('body').css('display', 'none');
    $('body').fadeIn(500);
});
